<template>
  <Vote :votes="votes" :vote-handler="vote" :can-vote="canVote" />
</template>
<script>
import Vote from "./Vote.vue";
import { getVotesBy, updateVote } from "../helpers/VoteApi";

export default {
  name: "VoteWrapper",
  components: { Vote },
  props: {
    voteProperty: String,
    voteValue: String,
    canVote: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      votes: [],
    }
  },
  methods: {
    loadVotes() {
      getVotesBy(this.voteProperty, this.voteValue).then(res => this.votes = res.data);
    },

    vote(like) {
      const data = { liked: like };
      data[this.voteProperty] = this.voteValue;
      this.votes = [];

      updateVote(data).then(res => this.loadVotes());
    }
  },
  mounted() {
    this.loadVotes();
  },
}
</script>
